import type { ReactNode } from "react";
import { App, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import { useTranslation } from "react-i18next";

const antdLocales = {
  "zh-CN": zhCN,
  "en-US": enUS,
} as const;

const theme = {
  token: {
    colorPrimary: "#6366F1",
    borderRadius: 8,
    fontFamily: "var(--font-sans)",
    colorLink: "#6366F1",
    colorSuccess: "#00B42A",
    colorSuccessBg: "#00B42A14",
    colorWarning: "#FF7D0AE5",
    colorWarningBg: "#FF7D0AE514",
    colorError: "#FF2929",
    colorErrorBg: "#FF292914",
    colorInfo: "#6366F1",
    colorInfoBg: "#6366F114",
    colorInfoBorder: "#6366F11A",
  },
  components: {
    // Figma：弹窗 content padding 20；确认弹窗标题 18px / 25px
    Modal: {
      contentPadding: 20,
      titleFontSize: 18,
      titleLineHeight: 25 / 18,
    },
  },
};

// 静态方法（Modal.confirm 等）不走 React context，需要单独挂上同一套主题
ConfigProvider.config({ theme });

/** 全局 Ant Design 主题 + 随 i18n 切换的组件文案 */
export function AntdProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const locale = antdLocales[i18n.language as keyof typeof antdLocales] ?? zhCN;

  return (
    <ConfigProvider locale={locale} theme={theme}>
      <App>{children}</App>
    </ConfigProvider>
  );
}
